<template>
  <div class='lt-welcome-page'>
    <header class='lt-welcome-page_content'>
      <h2 class="lt-welcome-title lt-welcome-title--large">
        Hitting <br /> The Target
      </h2>

      <p>Build a picture of your lifestyle in retirement by taking this quick quiz.</p>
      <p>Then, find out how much money you’d need each year to achieve it - and how much you should be saving now to meet your target.</p>
    </header>

    <div class='lt-fyf-footer'>
      <button
        class="lt-button lt-welcome-page_start-btn"
        @click='startQuiz'
      >
        Start Building Your Future
      </button>
    </div>
  </div>
</template>

<script>
import DefaultWelcomePage from '../../../src/views/WelcomePage';

export default {
  extends: DefaultWelcomePage,
};
</script>

<style lang='scss'>

.lt-welcome-page_content {
  background: $main-background;
  color: $main-color;
  box-shadow: 0 7px 5px 0px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 1.875rem 2.5rem;
  max-width: 720px;
  box-sizing: border-box;
  position: relative;
  text-align: center;
  @include breakpoint-portrait {
     padding: 1.875rem 1.25rem 1.25rem 1.25rem;
    @media (max-width: 21.875em) {
      padding: 1.25rem;
    }
  }
  .lt-welcome-title {
  margin: 0;
  line-height: .95;
  font-size: 3rem;
  text-transform: uppercase;

  @media (max-width: 500px) {
    font-size: 2rem;
  }

  }
  .lt-welcome-title--large {
    font-size: 4rem;
    @media (max-width: 600px) {
      font-size: 3rem;
    }
  }
  p {
    margin: 1.25rem 0;
    @include breakpoint-portrait {
      @media (max-width: 21.875em) {
        margin: 0.625rem 0 1.25rem 0;
      }
    }
  }
}

.lt-button.lt-welcome-page_start-btn {
  background: #d99f00;
  color: #102c43;
  font-weight: bold;
  &:hover {
    background: #CA830D;
  }
}

</style>
